import { api } from "./api";
import { API_URL } from "../utils/headers";

/**
 * Catálogo público y edición del perfil de una modelo.
 *
 * Los endpoints bajo `/public` no requieren sesión: sirven el material
 * promocional (fotos, videos cortos y textos) y nunca exponen la clave de
 * emisión. Los de `/model` sí, y el servidor decide con la policy si quien
 * pide es quien administra perfiles o la dueña del suyo.
 */

/* ------------------------------- Público ------------------------------- */

export const fetchPublicModelsService = (params = {}) =>
    api.get('/public/models', { params, auth: false });

export const fetchPublicModelService = ({ slug }) =>
    api.get(`/public/models/${slug}`, { auth: false });

/** Miniatura en vivo, servida por la API para no filtrar la clave de emisión. */
export const publicModelPreviewUrl = (slug) => `${API_URL}/public/models/${slug}/preview`;

/* ------------------------------- Perfil -------------------------------- */

export const updateModelProfileService = (modelId, body) =>
    api.put(`/model/${modelId}/profile`, body);

/** Imagen apaisada de la cabecera de la página pública. */
export const uploadModelCoverService = (modelId, file) => {
    const formData = new FormData();
    formData.append('file', file);

    return api.post(`/model/${modelId}/cover`, formData);
};

/* -------------------------- Material promocional ----------------------- */

export const fetchModelMediaService = ({ modelId }) => api.get(`/model/${modelId}/media`);

export const uploadModelMediaService = (modelId, file, meta = {}) => {
    const formData = new FormData();
    formData.append('file', file);

    Object.entries(meta).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            formData.append(key, value);
        }
    });

    return api.post(`/model/${modelId}/media`, formData);
};

export const updateModelMediaService = (modelId, mediaId, body) =>
    api.put(`/model/${modelId}/media/${mediaId}`, body);

export const deleteModelMediaService = (modelId, mediaId) =>
    api.delete(`/model/${modelId}/media/${mediaId}`);

export const reorderModelMediaService = (modelId, ids) =>
    api.put(`/model/${modelId}/media/reorder`, { ids });
